import _classCallCheck from "/builds/1800Flowers/apps/ui/mbp/mbp-pwa-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/1800Flowers/apps/ui/mbp/mbp-pwa-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function noop() {}
var defaultDispose = noop;
var _WeakRef = typeof WeakRef !== "undefined" ? WeakRef : function (value) {
  return {
    deref: function deref() {
      return value;
    }
  };
};
var _WeakMap = typeof WeakMap !== "undefined" ? WeakMap : Map;
var _FinalizationRegistry = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : function () {
  return {
    register: noop,
    unregister: noop
  };
};
var finalizationBatchSize = 10024;
export var WeakCache = /*#__PURE__*/function () {
  function WeakCache() {
    var _this = this;
    var max = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Infinity;
    var dispose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultDispose;
    _classCallCheck(this, WeakCache);
    this.max = max;
    this.dispose = dispose;
    this.map = new _WeakMap();
    this.newest = null;
    this.oldest = null;
    this.unfinalizedNodes = new Set();
    this.finalizationScheduled = false;
    this.size = 0;
    this.finalize = function () {
      var iterator = _this.unfinalizedNodes.values();
      for (var i = 0; i < finalizationBatchSize; i++) {
        var node = iterator.next().value;
        if (!node) break;
        _this.unfinalizedNodes.delete(node);
        var key = node.key;
        delete node.key;
        node.keyRef = new _WeakRef(key);
        _this.registry.register(key, node, node);
      }
      if (_this.unfinalizedNodes.size > 0) {
        queueMicrotask(_this.finalize);
      } else {
        _this.finalizationScheduled = false;
      }
    };
    this.registry = new _FinalizationRegistry(this.deleteNode.bind(this));
  }
  return _createClass(WeakCache, [{
    key: "has",
    value: function has(key) {
      return this.map.has(key);
    }
  }, {
    key: "get",
    value: function get(key) {
      var node = this.getNode(key);
      return node && node.value;
    }
  }, {
    key: "getNode",
    value: function getNode(key) {
      var node = this.map.get(key);
      if (node && node !== this.newest) {
        var older = node.older,
          newer = node.newer;
        if (newer) {
          newer.older = older;
        }
        if (older) {
          older.newer = newer;
        }
        node.older = this.newest;
        node.older.newer = node;
        node.newer = null;
        this.newest = node;
        if (node === this.oldest) {
          this.oldest = newer;
        }
      }
      return node;
    }
  }, {
    key: "set",
    value: function set(key, value) {
      var node = this.getNode(key);
      if (node) {
        return node.value = value;
      }
      node = {
        key: key,
        value: value,
        newer: null,
        older: this.newest
      };
      if (this.newest) {
        this.newest.newer = node;
      }
      this.newest = node;
      this.oldest = this.oldest || node;
      this.scheduleFinalization(node);
      this.map.set(key, node);
      this.size++;
      return node.value;
    }
  }, {
    key: "clean",
    value: function clean() {
      while (this.oldest && this.size > this.max) {
        this.deleteNode(this.oldest);
      }
    }
  }, {
    key: "deleteNode",
    value: function deleteNode(node) {
      if (node === this.newest) {
        this.newest = node.older;
      }
      if (node === this.oldest) {
        this.oldest = node.newer;
      }
      if (node.newer) {
        node.newer.older = node.older;
      }
      if (node.older) {
        node.older.newer = node.newer;
      }
      this.size--;
      var key = node.key || node.keyRef && node.keyRef.deref();
      this.dispose(node.value, key);
      if (!node.keyRef) {
        this.unfinalizedNodes.delete(node);
      } else {
        this.registry.unregister(node);
      }
      if (key) this.map.delete(key);
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      var node = this.map.get(key);
      if (node) {
        this.deleteNode(node);
        return true;
      }
      return false;
    }
  }, {
    key: "scheduleFinalization",
    value: function scheduleFinalization(node) {
      this.unfinalizedNodes.add(node);
      if (!this.finalizationScheduled) {
        this.finalizationScheduled = true;
        queueMicrotask(this.finalize);
      }
    }
  }]);
}();